export enum LandingPage {
    expoWest2023 = 'expo-west-2023',
}
